//FIXME: misleading name
//TODO: This should be refactored to be resuseable
$('body').on('click', '.datepick', function () {
  if ($(this).hasClass('stayOpen')) {
    $('.dropdown').addClass('open');
  }
});
